<template>
<div>

    <h5>*Для отбражения деталей нажми на изображение</h5>

    <table class="table  table-hover table-responsive table-bordered mt-3">
        <thead>
            <tr>
                <th>Детали*</th>
                <th>Наименование</th>
                <th>Наличие</th>
                <th>Стоимость</th>
                <th class="center">Добавить в корзину</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="(i, index) in items" :key="index">
                <td class="center">
                    <tab-modal :item="i"></tab-modal>
                </td>
                <td style="text-align: justify;width: 100%;">
                    {{i.Name}}
                </td>
                <td class="center">На складе Березники</td>
                <td class="center">
                    <strong> {{getPrice(i.Price.toString())}}<i class="fa fa-rub" area-hidden="true"></i></strong>
                </td>
                <td class="tocart" @click="addCart(i)">
                    <b-btn variant="info" v-if="inCart(i.Code) ==-1">
                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                    </b-btn>
                    <b-btn variant="danger" v-else disabled>
                        <i class="fa fa-ban" aria-hidden="true"></i>
                    </b-btn>
                </td>

            </tr>
        </tbody>
    </table>

</div>
</template>

<script>
import TabModal from "../components/TabModal"

export default {
    props: ['items'],
    methods: {
        addCart(item) {
            console.log(item)
            let data = {}
            data.id = item.Code
            data.short = item.Name
            data.img = './src/assets/FotoTovarov/' + item.Code + '.jpg'
            data.price = item.Price
            data.nal = 'true'
            data.count = 1
            data.sklad = 'ligasound'
            data.maxCount = item.Number
            this.$store.commit('cart/add', data)
        },
        inCart(id) {
            let arr = this.$store.getters['cart/inCart']
            return arr.indexOf(id)
        },
        getPrice(price) {
            let reg = /(\d)(?=(\d\d\d)+([^\d]|$))/g
            return price.replace(reg, '$1 ')

        }
    },    
        components: {
            TabModal
        },
    
}
</script>

<style scoped>
tr {
    cursor: pointer;
}

.tocart,
.center {
    text-align: center;
    vertical-align: inherit;
}



button:disabled {
    cursor: not-allowed;
}

th {
    vertical-align: middle !important;
}
</style>
